import {TXHR} from '../../assets/constants/constansts.type';
// TODO: Check types when use typescript

export const AVENUE_QUERY_PARAM = 'avenue';

export interface TPackagesProducer {
    billingName: string | null;
    billingId: string | null;
    phone: string | null;
    email: string | null;
    address: string | null;
    city: string | null;
    zipCode: string | null;
    contactName: string | null;
    contactPhone: string | null;
    contactEmail: string | null;
    branding: number | null;
    brandingSms: string | null;
    brandingEmail: string | null;
    isBusiness: number | null;
    verifiedEmail: number | null;
    countryCode: string | null;
    contactCountryCode: string | null;
    contactImage?: string | null;
    contactImageId?: number | null;
    contactSocialLinks?: {type: string, url: string, label?: string}[];
}

export type THubEvent = {
    eid: number;
    title: string | null;
    fbImg: string | null;
};

export interface TAccount {
    pid: number;
    title: string | null;
    bankVerifiedSent: boolean | null;
    bankVerified: number;
    packageVerified: boolean | null;
    userAccountRole: string | null;
    hasMoneyTransaction: boolean | null;
    mailingJson: any | null;
    countEvents: number | null;
    hasHubEvents: number | null;
    avenueEid: number | null;
    avenueHubEvents: THubEvent[] | null;
    permissions: any[];
    userPermissions: any[];
    termsVerified: boolean | null;
    events: any[];
    // Local account properties
    langloc: string | null;
    defaultTimeZone: string | null;
    type: string | null;
    billPackage: Record<string, any>;
    endDate: string | null;
    freeTickets: number | null;
    mailingPackage: any;
    mailingPackageList: any[];
    packageType: string | null;
    startDate: string | null;
    supplier: any | null;
    packagesProducer: TPackagesProducer | null;
    packagesBankDetails: any | null;
    bank: Record<string, any>;
    budgetItems: any[];
    owner: any | null;
    updated: any | null;
    createEvent: any | null;
    packageSuppliers: any[];
    packageEvents: any[];
    ownerEmail: string | null;
    ownerEmailVerified: number;
    securityBankToken: string | null;

    // XHR states
    getPackageProducerXHR: TXHR;
    updatePackageProducerXHR: TXHR;
    updateAccountPermissionXHR: TXHR;
    getAccountXHR: TXHR;
    getAccountSettingsXHR: TXHR;
    getMailingCountXHR: TXHR;
    updateAccountXHR: TXHR;
    sendPackageVerificationXHR: TXHR;
    getPackageBankXHR: TXHR;
    updatePackageBankXHR: TXHR;
    updatePackageVerificationXHR: TXHR;
    addPackageBankXHR: TXHR;
    getBudgetItemsXHR: TXHR;
    addBudgetItemXHR: TXHR;
    updateBudgetItemXHR: TXHR;
    createEventXHR: TXHR;
    getAccountSuppliersXHR: TXHR;
    deleteAccountSupplierXHR: TXHR;
    updateAccountSuppliersXHR: TXHR;
    addAccountSuppliersXHR: TXHR;
    getSuppliersInfoXHR: TXHR;
    updateAccountBillXHR: TXHR;
    createEasyCourseXHR: TXHR;
    updateVerifiedEmailXHR: TXHR;
    getAccountUserPermissionsXHR: TXHR;
    getAccountClubPermissionsXHR: TXHR;
    getAccountEventsXHR: TXHR;
    avenueHubEventsXHR: TXHR;
}
